import React, { useMemo } from 'react';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import './index.scss';
import IconDom from '@intelligence/components/SelectCompoenet/ItemDom/IconDom';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import { Segment } from 'tea-component';
import { hideByDateType } from './config';
interface ShotProps {
  shotList: any[];
  onChange: (value: any) => void;
  selectedMetrics: string;
  shotSelect: string;
  type: string;
  loading?: boolean;
}

const ShotSelection = (props: ShotProps) => {
  const { shotList = [], onChange, shotSelect, selectedMetrics, type, loading = true } = props;
  const { formatMessage } = useIntlExtend();
  const handleClickShotItem = (shotItemValue: string) => {
    onChange(shotItemValue);
  };

  const shotSelectCur = useMemo(() => {
    if (loading) return '';
    return shotSelect;
  }, [shotSelect, loading]);

  const getIconCur = (shotValue: any, dataSource: any) => {
    if (shotValue === 'ampere' && dataSource === 'ampere') {
      return 'amperewhite';
    }
    if (shotValue === 'databrain' && dataSource === 'databrainbluebg') {
      return 'databrainbgresized'; // 返回databrain被选中时的特殊图标
    }
    if (shotValue === 'alinea' && dataSource === 'alinea') {
      return 'alineawhite';
    }
    return dataSource;
  };

  const lists = useMemo(() => {
    const typeEmun: any = hideByDateType[type];
    // const list = shotList?.filter((element) => !typeEmun?.includes(element.value));
    return shotList?.map((shotItem) => {
      const label = formatMessage({ id: shotItem.text });
      const isDisabled = shotItem?.disabled || typeEmun?.includes(shotItem?.value);
      return {
        value: shotItem.value,
        text:
          selectedMetrics === 'dataSource' ? (
            <div className={'dbi_metric_select_segment_item'}>
              {shotItem.value !== 'all' ? (
                <IconDom
                  data={{
                    img: getDataSourceIcon(
                      getIconCur(shotSelectCur, shotItem?.icon || shotItem?.value),
                    ),
                    text: label,
                    tooltip: label,
                    hideText: true,
                    disabled: isDisabled,
                  }}
                />
              ) : null}
              {label}
            </div>
          ) : (
            label
          ),
        disabled: isDisabled,
      };
    });
  }, [JSON.stringify(shotList), formatMessage, type, shotSelectCur]);
  return (
    <Segment
      className="segment-light details-storerank-segment"
      value={shotSelectCur}
      options={lists}
      onChange={handleClickShotItem}
    />
  );
};
export default ShotSelection;
